export default {
  TableHead: [
    [
      {
        displayName: 'report.onlineuser.datatable.number',
      },
      {
        displayName: 'lotto.date',
      },
      {
        displayName: 'lotto.round_id',
      },
      {
        displayName: 'lotto.round',
      },
      {
        displayName: 'lotto.winner_number',
      },
      {
        displayName: 'lotto.bet',
      },
      {
        displayName: 'lotto.total_bet',
      },
      {
        displayName: 'lotto.payout',
      },
      {
        displayName: 'lotto.total_payout',
      },
    ],
  ],
};
